import { useTranslation } from "react-i18next";
import IconInputDate from "../../../../components/input/IconInputDate";
import { PlusIcon } from "../../../../components/icons";
import { Collapse } from "../../../../components/motion";

const DuplicateBooking = ({
    lang,
    isRecurring,
    setIsRecurring,
    inputFields,
    setInputFields,
    inputFieldsToShow,
    setInputFieldsToShow,
    inputFieldsToShowFormated,
    setInputFieldsToShowFormated,
    onChangeDuplicateDate,
    removeDateByIndex,
    handleAddDate,
}) => {
    const { t } = useTranslation();
    return (
        <div className="tw:!mb-5">
            <div className="tw:!mb-3">
                <p className="tw:!m-0 tw:!font-[400] tw:!text-[15px] noto">
                    {t("BookingConfirmation.DuplicateBooking.Title")}
                </p>
            </div>
            <div className="tw:!mb-3">
                <div className="tw:flex tw:gap-2">
                    <div
                        className={`tw:!border tw:!border-[#D9D9D9] tw:rounded twh-100 tw:cursor-pointer tw:w-full tw:!w-2/2 tw:md:!w-1/2`}
                        onClick={() => {
                            setInputFields([""])
                            setInputFieldsToShow([""])
                            setInputFieldsToShowFormated([""])
                            setIsRecurring(false)
                        }}
                    >
                        <div className="tw:!flex tw:gap-2 tw:!px-3 tw:!py-3 tw:justify-start tw:items-center tw:h-full">
                            <input
                                className="form-check-input-meet-assist"
                                type="radio"
                                name="onTimeBooking"
                                id="onTimeBooking"
                                checked={!isRecurring}
                                onChange={() => setIsRecurring(false)}
                            />
                            <label
                                className={`tw:cursor-pointer tw:!text-[15px] tw:!text-[#282828] tw:!font-[400] `}
                                htmlFor="onTimeBooking"
                            >
                                {t("BookingConfirmation.DuplicateBooking.OneTime")}
                            </label>
                        </div>
                    </div>
                    <div
                        className={`tw:!border tw:!border-[#D9D9D9] tw:rounded twh-100 tw:cursor-pointer tw:w-full tw:!w-2/2 tw:md:!w-1/2`}
                        onClick={() => setIsRecurring(true)}
                    >
                        <div className="tw:!flex tw:gap-2 tw:!px-3 tw:!py-3 tw:justify-start tw:items-center tw:h-full">
                            <input
                                className="form-check-input-meet-assist"
                                type="radio"
                                name="recurringBooking"
                                id="recurringBooking"
                                checked={isRecurring}
                                onChange={() => setIsRecurring(true)}
                            />
                            <label
                                className={`tw:cursor-pointer tw:!text-[15px] tw:!text-[#282828] tw:!font-[400] `}
                                htmlFor="recurringBooking"
                            >
                                {t("BookingConfirmation.DuplicateBooking.DuplicateBookingOtherDay")}
                            </label>
                        </div>
                    </div>
                </div>
            </div>
            {/* Opens smoothly when "duplicate on other days" is chosen. */}
            <Collapse isOpen={isRecurring}>
                <div className="tw:!mb-3">
                    <p className="tw:!m-0 tw:!font-[400] tw:!text-[15px] noto tw:!mb-3">
                        {t("BookingConfirmation.DuplicateBooking.DuplicateTransferOn")}
                    </p>
                    <div className="tw:flex tw:flex-wrap tw:items-center tw:justify-start tw:mb-3">
                        {inputFields.map((_, index) => (
                            <div
                                key={index}
                                className="tw:w-auto tw:mb-2 tw:pe-2 tw:w-full tw:md:w-1/3 tw:w-1/1"
                            >
                                <IconInputDate
                                    index={index}
                                    lang={lang}
                                    selectedDate={inputFieldsToShow[index]}
                                    formattedDate={inputFieldsToShowFormated[index]}
                                    onSelectDate={onChangeDuplicateDate}
                                    onRemoveDate={removeDateByIndex}
                                    t={t}
                                    placeholder={t("BookingConfirmation.DuplicateBooking.Placeholder")}
                                />
                            </div>
                        ))}

                        <div className="tw:w-auto tw:mb-2 tw:pe-2 tw:w-full tw:md:w-1/3 tw:w-1/1">
                            <button
                                type="button"
                                className="tw:inline-block tw:font-normal tw:leading-normal tw:text-center tw:no-underline tw:align-middle tw:cursor-pointer tw:select-none tw:border tw:border-transparent tw:px-3 tw:py-[0.375rem] tw:text-base tw:rounded-[0.25rem] tw:transition-[color,background-color,border-color,box-shadow] tw:duration-150 tw:disabled:opacity-65 tw:disabled:pointer-events-none tw:!bg-[#F9EDD3] tw:!flex tw:!items-center tw:!justify-center tw:!gap-2 tw:!py-3 tw:!px-4 tw:!rounded tw:!text-[15px] tw:!font-[400] tw:!text-[#4E4E4E] tw:w-full"
                                onClick={handleAddDate}
                                disabled={inputFields[0] === ""}
                            >
                                <PlusIcon color="#666666" size={10} />
                                {t("BookingConfirmation.DuplicateBooking.AddDateButton")}
                            </button>
                        </div>
                    </div>

                    <p className="tw:!m-0 tw:!p-0">
                        {t("BookingConfirmation.DuplicateBooking.DuplicateInfo", {
                            count: inputFields.filter(v => v !== "").length
                        })}
                    </p>

                </div>
            </Collapse>
        </div>
    );
};

export default DuplicateBooking;
